module.exports = __webpack_public_path__ + "media/images/modal/Pop-Up_Altcoins-73ad88af19ad7d22749d8fae6498883f.png";